import {InvitationModel, InvitationRequests, InvitationStatusEnum} from "@/app/api/invitation";
import {UserRequests} from "@/app/api/user";

export interface BatchesForView {
  batchId: string,
  status?: InvitationStatusEnum,
  anotherInvitations: InvitationModel[],
}

export async function groupInvitationsToBatches(invitations: InvitationModel[]): Promise<BatchesForView[]> {
  const uniqueBatchIds = Array.from(new Set(invitations.map(inv => inv.batchId)));
  const currentUser = await UserRequests.getCurrentUser();

  const batches: BatchesForView[] = await Promise.all(uniqueBatchIds.map(async batchId => {
    let batch = await InvitationRequests.getInvitationsByBatchId(batchId);

    const targetIndex = batch.findIndex(i => i.toUserId === currentUser.user.id);

    if (targetIndex !== -1) {
      const userById = await UserRequests.getUserById(batch[targetIndex].fromUserId);

      batch[targetIndex] = {
        ...batch[targetIndex],
        toUserId: userById.user.id,
        toUsername: userById.user.username ?? "",
        toUserImageUrl: userById.user.imageLink ?? "",
      };
    }

    let status: InvitationStatusEnum | undefined = undefined;
    if (batch.every(i => i.status === InvitationStatusEnum.ACCEPTED)) status = InvitationStatusEnum.ACCEPTED;
    else if (batch.every(i => i.status === InvitationStatusEnum.PENDING)) status = InvitationStatusEnum.PENDING;
    else if (batch.every(i => i.status === InvitationStatusEnum.COMPLETED)) status = InvitationStatusEnum.COMPLETED;
    else status = InvitationStatusEnum.PENDING;

    return {batchId, status, anotherInvitations: batch};
  }));

  return batches;
}